// src/index.ts
export * from "./ajax";
export * from "./anchor";
export * from "./color";
export * from "./config";
import * as DOM from "./dom";
export * from "./env";
export * from "./event";
export * from "./geo";
import { BKDRHash, djb2hash, guid } from "./hash";
export * from "./lineAtOffset";
export * from "./lodash-adapter";
export * from "./lru_cache";
export * from "./math";
import * as Satistics from "./statistics";
export * from "./tileset-manager";
function defaultValue(v1, v2) {
  if (v1 === void 0 || v1 === null) {
    return v2;
  }
  return v1;
}
export {
  BKDRHash,
  DOM,
  Satistics,
  defaultValue,
  djb2hash,
  guid
};
